export const formatFileSize = bytes => {
	if (bytes < 1024) {
		return `${bytes} B`;
	}

	if (bytes < 1024 * 1024) {
		return `${(bytes / 1024).toFixed(0)} KB`;
	}

	return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

// `createFile`'s response shape isn't documented on the frontend: this handles both
// a single created-file object and an array, falling back to a client-only id when
// the server doesn't echo one back (remove then only clears the local list).
export const normalizeUploadedFiles = (data, sourceFiles) => {
	const entries = Array.isArray(data) ? data : [data];

	return sourceFiles.map((file, index) => {
		const entry = entries[index] || entries[0] || {};

		return {
			id: entry.id ?? `${file.name}-${file.lastModified}`,
			name: entry.name || entry.original_name || file.name,
			sizeLabel: formatFileSize(file.size)
		};
	});
};
